import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getAppTagTree() {
  return request({
    url: `${v2Host}/common/apptag/app-tag-tree`,
    method: 'get',
  })
}

export function getProjectTagTree() {
  return request({
    url: `${v2Host}/common/apptag/project-tag-tree`,
    method: 'get',
  })
}
